<script lang="ts">
  import type { FirstStepContactForm } from '@features/contactUs/config/first-step';
  import { contactUsForm, ContactUsStep, type ContactUsForm } from '../config/store';
  import FirstStep from './first-step.svelte';
  import SecondStep from './second-step.svelte';
  import Success from './success.svelte';
  import StepSwitch from '@features/contactUs/ui/step-switch.svelte';
  import type { SecondStepContactForm } from '@features/contactUs/config/second-step';
  import { PUBLIC_API_URL } from '$env/static/public';

  export let data: { firstStep: FirstStepContactForm; secondStep: SecondStepContactForm };
  let container: HTMLDivElement;

  const handleSubmit = async (formData: { detail: ContactUsForm }) => {
    if ($contactUsForm.step === ContactUsStep.First) {
      contactUsForm.updateForm(formData.detail);
      contactUsForm.updateStep(ContactUsStep.Second);

      window.scrollTo({
        top: container.offsetTop - 72,
        behavior: 'smooth',
      });

      return;
    }

    try {
      const { email, full_name, major, phone } = $contactUsForm.form;
      const { inquiry_type, message } = formData.detail;

      const newData = {
        email,
        major,
        phone,
        full_name,
        inquiry_type,
        message,
        from: 'store',
      };

      await fetch(`${PUBLIC_API_URL}/info/contact-us`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newData),
      });

      window.scrollTo({
        top: container.offsetTop - 72,
        behavior: 'smooth',
      });

      contactUsForm.updateStep(ContactUsStep.Success);
    } catch {
      console.error('Error while sending data');
    }
  };
</script>

{#if $contactUsForm.step !== 'success'}
  <div bind:this="{container}">
    <StepSwitch />
  </div>
{/if}

{#if $contactUsForm.step === 'first'}
  <FirstStep formData="{data.firstStep}" on:successSubmit="{handleSubmit}" />
{:else if $contactUsForm.step === 'second'}
  <SecondStep formData="{data.secondStep}" on:successSubmit="{handleSubmit}" />
{:else}
  <Success />
{/if}
